/**
 * Debug utility for the Compare Tool
 * 
 * AIDEV-NOTE: Set DEBUG to false before production deployment
 * This controls whether debug messages are logged to the console
 */

// Set to true for development, false for production
export const DEBUG = false;

/**
 * Log debug messages only when DEBUG is enabled
 * @param message - Primary message to log
 * @param data - Optional data to log
 */
export const debug = (message: string, data?: any) => {
  if (DEBUG) {
    if (data !== undefined) {
      console.log(`[DEBUG] ${message}`, data);
    } else {
      console.log(`[DEBUG] ${message}`);
    }
  }
};

/**
 * Log warning messages (these will show regardless of DEBUG flag)
 * @param message - Primary message to log
 * @param data - Optional data to log
 */
export const warn = (message: string, data?: any) => {
  if (data !== undefined) {
    console.warn(`[WARN] ${message}`, data);
  } else {
    console.warn(`[WARN] ${message}`);
  }
};

/**
 * Log error messages (these will show regardless of DEBUG flag)
 * @param message - Primary message to log
 * @param data - Optional data to log
 */
export const error = (message: string, data?: any) => {
  if (data !== undefined) {
    console.error(`[ERROR] ${message}`, data);
  } else {
    console.error(`[ERROR] ${message}`);
  }
};